import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const whyChooseUsData = {
    title: "Why Choose Us?",
    description: "A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole",
    points: [
      "End-to-End Expertise: Full-spectrum services from market entry to daily operations",
      "Regulatory Excellence: Deep knowledge of India's business and compliance landscape", 
      " Integrity & Ethics: Unwavering commitment to regulatory integrity and transparency",
      "Tailored Engagements: Customized solutions aligned to your operational model",
      "Global Standards: Bridging global business goals with Indian execution dynamics"
    ]
  };

  return (
    <section className="whychooseus">
      <div className="whychooseus-container">
        <div className="whychooseus-content">
          <div className="whychooseus-badge">
            {whyChooseUsData.badge}
          </div>
          
          <h2 className="whychooseus-title">{whyChooseUsData.title}</h2>
          
          <p className="whychooseus-description">
            {whyChooseUsData.description}
          </p>
          
          <ul className="whychooseus-list">
            {whyChooseUsData.points.map((point, index) => (
              <li key={index} className="whychooseus-item">
                <span className="whychooseus-icon">✓</span>
                <span className="whychooseus-text">{point}</span>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="whychooseus-image-container">
          <div className="whychooseus-image">
            <img 
              src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
              alt="Business professionals discussing in modern office"
              className="whychooseus-photo"
              loading="lazy"
            />
            <div className="image-overlay"></div>
          </div>
        </div>
      </div>
      
      {/* Background decoration */}
      <div className="background-decoration">
        <div className="decoration-circle decoration-circle-1"></div>
        <div className="decoration-circle decoration-circle-2"></div>
        <div className="decoration-circle decoration-circle-3"></div>
        <div className="decoration-circle decoration-circle-1"></div>
        <div className="decoration-circle decoration-circle-2"></div>
      </div>
    </section>
  );
};

export default WhyChooseUs;